import React from "react";
import i18n from "../../i18n";

import { Button, MenuItem, Tag } from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";

export default class EventSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      filter: "",
    };
  }

  getUnSelectedEvent() {
    let list = Array.from(Array(1000).keys())
      .filter((id) => i18n.t("event" + id) !== "event" + id)
      .filter((id) => this.props.value.indexOf(id) === -1);

    return list;
  }

  render() {
    const ret = [];
    for (const e of this.props.value !== undefined ? this.props.value : []) {
      ret.push(
        <Tag
          key={"ev" + e}
          onRemove={() => {
            this.props.onSelectionChange(
              this.props.value.filter((item) => item !== e)
            );
          }}
          large={true}
        >
          {i18n.t("event" + e)}
        </Tag>
      );
    }

    return (
      <div>
        <div className="flexbox-left">{ret}</div>
        {this.state.open ? (
          <Select
            items={this.getUnSelectedEvent().filter(
              (item) =>
                item != null &&
                i18n
                  .t("event" + item)
                  .toUpperCase()
                  .includes(this.state.filter.toUpperCase())
            )}
            itemRenderer={(item) => {
              return (
                <MenuItem
                  label={i18n.t("event" + item)}
                  text={item}
                  key={item}
                  onClick={() => {
                    this.setState({ open: false }, () => {
                      this.props.onSelectionChange([...this.props.value, item]);
                    });
                  }}
                />
              );
            }}
            // controlled query
            query={this.state.filter}
            onQueryChange={(f) => this.setState({ filter: f })}
          >
            <Button
              text={
                this.state.event !== undefined
                  ? i18n.t("event" + this.state.event)
                  : i18n.t("select an event to add")
              }
              rightIcon="double-caret-vertical"
            />
          </Select>
        ) : (
          <Button
            onClick={() => {
              this.setState({ open: true });
            }}
            icon="add"
          />
        )}
      </div>
    );
  }
}
